<template>
<section class="menu">
    <!-- <h2 class="menuHeader">메뉴</h2> -->
    <section class="user_menu_section">
        <div class="wrap">
            <div class="user_menu">
                <template v-if="!loginChk">
                    <p @click="$router.push('/login')">
                        <a>로그인ㆍ회원가입 <i class="far fa-chevron-right"></i></a>
                    </p>
                </template>
                <template v-else>
                    <p>{{auth.name}} 님</p>
                    <a v-if="socialCheck('KAKAO')"><img :src="$store.state.resource.imgIconKakao" width="20">kakao</a>
                    <a v-if="socialCheck('GOOGLE')"><img :src="$store.state.resource.imgIconGoogle" width="20">google</a>
                    <a v-if="socialCheck('APPLE')"><img :src="$store.state.resource.imgIconApple" width="20">apple</a>
                </template>

            </div>
            
            <div class="menu_user_img" v-if="!loginChk"> 
                <img src="images/user_icon.png">
            </div> 
            
            <div v-else> 
                <a @click="logOut()" class="logout_btn">Log Out</a>
            </div> 

        </div>
    </section>
    <div class="wrap">
        <ul class="menu_ul">
            <li v-if="loginChk">
                <ul>
                    <MenuItem title="계정 정보" to="/myInfo"></MenuItem>
                    <MenuItem title="내가 남긴 방문 후기" to="/myReview"></MenuItem>
                </ul>
            </li>
            <li>
                <ul>
                    <MenuItem title="딜러사 둘러보기" to="/brandSelect"></MenuItem>
                    <MenuItem title="파트너스 컨텐츠" to="/newsList"></MenuItem>
                </ul>
            </li>
            <li>
                <ul>
                    <MenuItem title="공지사항" to="/noticeList"></MenuItem>
                    <MenuItem title="자주묻는 질문" to="/faqList"></MenuItem>
                    <MenuItem title="1:1 문의" to="/qna" v-if="loginChk"></MenuItem>
                    <MenuItem title="서비스 이용약관" to="/termList"></MenuItem>
                    <MenuItem title="개인정보 처리방침" to="/privacyList"></MenuItem>
                </ul>
            </li>
        </ul>
    </div>
</section>
</template>
<style>
    .menu_ul >li:last-child {
        border-bottom: none;
    }
</style>
<script>
import MenuItem from './MenuItem.vue';

export default {
    name:'Menu',
    components: {
        MenuItem,
    },
    
    created () {
        this.$store.state.footer = true;
        this.$store.state.headerTitle = '메뉴';
        this.$store.commit('SHOW_ONLOAD');
    },

    computed: {},

    methods: {
        logOut() {
            this.$store.commit('OPEN_MODAL', {
                content: '로그아웃 하시겠습니까?',
                btnOne:'예',
                btnOneSubmit: () => {
                    this.$store.dispatch('LOGOUT')
                    .then(()=>{
                        this.$store.commit('OPEN_MODAL', {
                            content:'로그아웃 되었습니다.',
                            btnOne:'확인',
                        })
                    });
                },
                btnTwo:'아니오',
            })
        },
    },
}
</script>

<style lang="scss" scoped>

</style>